import { BasicClient } from '@/utils/httpClient'

export default class ExternalAuthService {
  client
  
  constructor() {
    this.client = new BasicClient()
  }
  
 /**
   * Valida un token JWT recibido desde una aplicación externa (padre)
   * @param {string} jwt - Token JWT recibido vía postMessage
   * @returns {Promise} - Respuesta del servidor con resultado de validación
   */
  validateExternalToken(jwt) {
    return this.client.exec('/validate-external-jwt', 'POST', { token : jwt })
  }
}
